import {ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {select, Store} from '@ngrx/store';
import {combineLatest, Observable} from 'rxjs';
import {distinctUntilChanged, filter, map, switchMap, take} from 'rxjs/operators';
import {ActionService} from 'src/app/core/services/action.service';
import {AuthService} from 'src/app/core/services/auth.service';
import {CommonService} from 'src/app/core/services/common.service';
import {RouteService} from 'src/app/core/services/route.service';
import {StorageService} from 'src/app/core/services/storage.service';
import {DeleteObject, LoadDependentRecords, LoadFormID} from 'src/app/core/state/_actions/form.actions';
import {ViewProcessRecordDetails} from 'src/app/core/state/_actions/process.actions';
import {LoadApplicationUsers, ReturnToSuperAdmin} from 'src/app/core/state/_actions/settings/application-users.actions';
import {DependentRecords} from 'src/app/core/state/_models/form.model';
import {OpTypes} from 'src/app/core/state/_models/general.model';
import {
  getApplicationById,
  getAppName,
} from 'src/app/core/state/_selectors/application.selector';
import {getDependentRecords, getFormIDs, getFormOperations} from 'src/app/core/state/_selectors/form.selector';
import {getProcessRecordDetails} from 'src/app/core/state/_selectors/process.selector';
import {getAllDashboards} from 'src/app/core/state/_selectors/settings/dashboards.selector';
import {getNavigation} from 'src/app/core/state/_selectors/table.selector';
import {ReportService} from 'src/app/core/state/_services/report.service';
import {AddClientComponent as AddClient} from 'src/app/modules/application/clients/add-client/add-client.component';
import {UpsertFieldComponent} from 'src/app/modules/application/field/upsert/upsert.component';
import {
  UpsertPageComponent
} from 'src/app/modules/application/settings/pages-dashboards/upsert-page/upsert-page.component';
import {
  UpsertUserComponent as AddUser
} from 'src/app/modules/application/settings/users/upsert-user/upsert-user.component';
import {UpsertComponent as AddTable} from 'src/app/modules/application/tables/upsert/upsert.component';
import {UpsertComponent as AddTemplate} from 'src/app/shared/components/templates/upsert/upsert.component';
import {SweetAlertOptions} from 'sweetalert2';
import {Roles} from '../../enums/role.enum';
import {alertPresets, AlertService} from '../../services/alert.service';
import {ExportService} from '../../services/export.service';
import {SearchService} from '../../services/search.service';
import {alertDefaultExtra} from '../datatable/datatable.constants';
import {
  addFormTemplateList,
  addNotificationTemplateList,
  addPageDashboardTemplateList,
  addRecordTemplateList,
  addReportTemplateList,
  addUserTemplateList,
  editRecordTemplateList,
  editUserInterfaceTemplateList,
} from './sub-header.constants';
import {FieldService} from 'src/app/core/state/_services/field.service';
import {SubSink} from 'subsink';
import {CompanyService} from 'src/app/core/state/_services/company.service';
import {environment} from 'src/environments/environment';
import {LaunchDarklyService} from 'src/app/core/services/launchdarkly.service';
import {FEATURE_FLAGS} from 'src/app/shared/launchdarkly.constants';
import {LDFlagValue} from 'launchdarkly-js-client-sdk';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
})
export class SubHeaderComponent implements OnInit, OnDestroy {
  @ViewChild('addReport', {static: true}) addReport!: TemplateRef<any>;
  @ViewChild('addUser', {static: true}) addUser!: TemplateRef<any>;
  @ViewChild('addTable', {static: true}) addTable!: TemplateRef<any>;
  @ViewChild('addTemplate', {static: true}) addTemplate!: TemplateRef<any>;
  @ViewChild('addPageDashboard', {static: true})
  addPageDashboard!: TemplateRef<any>;
  @ViewChild('addForm', {static: true}) addForm!: TemplateRef<any>;
  @ViewChild('addNotification', {static: true})
  addNotification!: TemplateRef<any>;
  @ViewChild('editRecord', {static: true})
  editRecord!: TemplateRef<any>;
  @ViewChild('addRecord', {static: true})
  addRecord!: TemplateRef<any>;
  @ViewChild('editUserInterface', {static: true})
  editUserInterface!: TemplateRef<any>;
  public isSearchVisible: boolean = false;
  public search: string = '';
  public addReportTemplateList = addReportTemplateList;
  public addUserTemplateList = addUserTemplateList;
  public addPageDashboardTemplateList = addPageDashboardTemplateList;
  public addFormTemplateList = addFormTemplateList;
  public addNotificationTemplateList = addNotificationTemplateList;
  public editRecordTemplateList = editRecordTemplateList;
  public addRecordTemplateList = addRecordTemplateList;
  public editUserInterfaceTemplateList = editUserInterfaceTemplateList;
  isHelpWidget: boolean = true;
  isChatWidget: boolean = false;
  appDetail$!: any;
  dashboards: any;
  appDetail: any;
  subsink: SubSink = new SubSink();
  IsHelpDeskWidgetActive: boolean = false;
  icon: boolean = false;
  isImpersonate: string | null = this.storageService.getImpersonateId();
  isBillingAdmin: boolean = false;
  isAdmin: boolean = false;
  isPortal: boolean = false;
  companyId: number | null = null;
  entityFriendlyId: string | null = null;  // Presence of value indicates it is an OG entity app
  controlPanelURL = environment.controlPanelURL;
  verticalDotsClass = 'icon-vert-dots'
  isGlobalNavVisible: boolean = false;

  // Feature flags
  enableAddUserWizard$!: Observable<LDFlagValue>;
  isAddUserWizardEnabled: boolean = false;  // Sync value for getter methods
  isOgInsightsEnabled: boolean = false;

  constructor(
    public authService: AuthService,
    private readonly modal: NgbModal,
    private readonly route: RouteService,
    public searchService: SearchService,
    private readonly store: Store,
    private readonly exportService: ExportService,
    private readonly report: ReportService,
    private readonly alert: AlertService,
    private readonly action: ActionService,
    private readonly commonService: CommonService,
    private readonly cdr: ChangeDetectorRef,
    private readonly storageService: StorageService,
    private readonly companyService: CompanyService,
    public fieldService: FieldService,
    private readonly ldService: LaunchDarklyService
  ) {
  }

  ngOnInit(): void {
    // Initialize feature flag observable
    this.enableAddUserWizard$ = this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_ADD_USER_WIZARD, false);

    this.subsink.add(
      this.route.change()?.subscribe(() => {
        this.search = '';
        if (this.isChatWidget) {
          this.isChatWidget = false;
        }
        this.getWidgetActiveStatus();
      }),
      this._subscribeToEntityFriendlyIdChanges(),
      // Subscribe to feature flag for sync access in getter methods
      this.enableAddUserWizard$.subscribe((value: LDFlagValue) => {
        this.isAddUserWizardEnabled = !!value;
      }),
      this.ldService.getFlagValue(FEATURE_FLAGS.ENABLE_OG_INSIGHTS_CHARTS, false)
        .subscribe((value: LDFlagValue) => {
          this.isOgInsightsEnabled = !!value;
        })
    );

    this.companyId = this.authService?.userProfile?.CompanyId;
    this.isBillingAdmin = this.storageService.getIsBillindAdmin() == 'true';
    this.isAdmin = this.storageService.getUserRole() == 'admin';
    this.isPortal = this.storageService.getPortalId() === null;
    this.getWidgetActiveStatus();
    this.commonService.setOGSupportActive(false);
    this.loadSubscribers();
  }

  private storageEventHandler: ((e: StorageEvent) => void) | null = null;
  private entityFriendlyIdUpdatedHandler: (() => void) | null = null;

  private _subscribeToEntityFriendlyIdChanges() {
    // Subscribe to changes in entityFriendlyId which is triggered on route change/changing apps
    // Read from storage service (set by sidebar component) to avoid duplicate API calls

    // Listen to localStorage storage events (for cross-tab updates)
    this.storageEventHandler = (e: StorageEvent) => {
      if (e.key === 'activeEntityFriendlyId') {
        // Always update - including null to clear stale values when switching apps
        this.entityFriendlyId = this.storageService.getEntityFriendlyId();
      }
    };
    window.addEventListener('storage', this.storageEventHandler);

    // Listen to custom event for same-window updates
    this.entityFriendlyIdUpdatedHandler = () => {
      // Always update - including null to clear stale values when switching apps
      this.entityFriendlyId = this.storageService.getEntityFriendlyId();
    };
    window.addEventListener('entityFriendlyIdUpdated', this.entityFriendlyIdUpdatedHandler);

    // Initial read from storage service
    this.entityFriendlyId = this.storageService.getEntityFriendlyId();

    // Also subscribe to route changes to read from storage service when app changes
    return this.route.change()?.pipe(
      map(() => this.getAppId()),
      distinctUntilChanged(), // Proceed if appId has changed
      map(() => {
        // Read from storage service on route change
        return this.storageService.getEntityFriendlyId();
      })
    ).subscribe(entityFriendlyId => {
      // Always update - including null to clear stale values when switching apps
      this.entityFriendlyId = entityFriendlyId;
    });
  }

  loadSubscribers = () => {
    this.appDetail$ = combineLatest([
      this.store.pipe(
        select(getAllDashboards),
        filter((dashboards) => !!dashboards[this.route.getApplicationKey()]),
        map((dashboards) => dashboards[this.route.getApplicationKey()])
      ),
    ]).subscribe((data: any) => {
      this.dashboards = data[0];
    });
    this.subsink.add(
      this.appDetail$,
      this.authService.loginLogoutSubject.subscribe(() => {
        this.isImpersonate = this.storageService.getImpersonateId();
      })
    );
  };

  openSupport() {
    window.open('https://support.opengov.com/', '_blank', 'noopener');
  }

  /**
   * @returns true if admin or super_admin
   */
  isAdminOrSuperAdmin() {
    return this.authService.userProfile?.Role === Roles.superAdmin ||
      this.authService.userProfile?.Role === Roles.admin;
  }

  isAuthorizedParticipant(right: string) {
    const applicationKey = this.route.getApplicationKey();
    const tableKey = this.route.getTableKey();
    const currentRoute = this.route.currentRoute();
    const buttonTextIncludes = (text: string) => this.buttonText?.includes(text);
    let hasCreateRight = false;
    let hasUpdateRight = false;
    let hasViewRight = false;

    const rights = {
      create: 0,
      update: 0,
      view: 0,
      manageReports: 0,
      manageForms: 0,
    };

    const setRights = (el: any) => {
      if (el.ApplicationKey === applicationKey || el.ApplicationId === applicationKey) {
        el.Rights?.forEach((permission: any) => {
          if (permission.ApplicationTableKey === tableKey || permission.ApplicationTableId === tableKey) {
            rights.create = permission.Create;
            rights.update = permission.Update;
            rights.view = permission.View;
          }
        });
      }
    };

    const setManageReports = (el: any) => {
      if (el.ApplicationKey === applicationKey) {
        el.ApplicationRoleManagements?.forEach((role: any) => {
          if (role.ApplicationTableKey === tableKey && role.ApplicationRoleManagementType?.Name === 'Manage Reports') {
            rights.manageReports = 1;
          }
        });
      }
    };
    const setManageForms = (el: any) => {
      if (el.ApplicationKey === applicationKey) {
        el.ApplicationRoleManagements?.forEach((role: any) => {
          if (role.ApplicationTableKey === tableKey && role.ApplicationRoleManagementType?.Name === 'Manage Forms') {
            rights.manageForms = 1;
          }
        });
      }
    };

    this.authService.userProfile?.ApplicationRoles?.forEach(setRights);
    const isReportsView = currentRoute.includes('reports/datatable/view') || currentRoute.includes('reports/details/view');
    const isManageReportsRoute = currentRoute === `/apps/${applicationKey}/tables/${tableKey}/reports`;
    const isManageFormsRoute = currentRoute === `/apps/${applicationKey}/tables/${tableKey}/forms`;
    const isReportsEdit = currentRoute.includes('/forms/action/edit');

    hasCreateRight = (rights.create === 1 && buttonTextIncludes('Add')) || false;
    hasUpdateRight = (rights.update === 1 && buttonTextIncludes('icon-vert-dots')) || false;
    hasViewRight = (rights.view === 1 && buttonTextIncludes('icon-vert-dots')) || false;

    if (right === 'dropDownDots') {
      return ((isReportsView || isReportsEdit) && (hasCreateRight || hasUpdateRight)) || hasViewRight;
    } else if (right === 'addRecord') {
      return isReportsView && hasCreateRight;
    } else {
      if (isManageReportsRoute) {
        this.authService.userProfile?.ApplicationRoles?.forEach(setManageReports);
        return rights.manageReports === 1;
      } else if (isManageFormsRoute) {
        this.authService.userProfile?.ApplicationRoles?.forEach(setManageForms);
        return rights.manageForms === 1;
      }
    }
    return false;
  }

  /**
   * Get application id
   */
  getAppId = () => this.route.getApplicationKey();

  /**
   * Get table id
   */
  getTableId = () => this.route.getTableKey();

  /**
   * Open popup for adding a table
   */
  openModal = async (opType: string = '') => {
    const component = await this.componentSelector();
    if (component === true) return;
    let size;
    if (['UpsertFieldComponent', 'UpsertPageComponent'].some((cls) =>
      component?.toString().includes(cls)
    )) {
      size = 'xl';
    } else if (['AddClientComponent'].some((cls) =>
      component?.toString().includes(cls)
    )) {
      size = 'lg';
    } else if (['UpsertUserComponent'].some((cls) =>
      component?.toString().includes(cls)
    )) {
      size = 'md';
    } else {
      size = 'md';
    }
    const modalRef = this.modal.open(component, {
      windowClass: 'modalHeader-custom modal-custom',
      centered: true,
      backdrop: 'static',
      animation: true,
      keyboard: false,
      size: size
    });
    this.cdr.detectChanges();

    if (opType) {
      modalRef.componentInstance.actionType = opType;
    }
  };

  /**
   * Can sub header render
   */
  canRender = () =>
    !['/', '/apps', '/user/profile', '/user/billing'].find(
      (route) => route === this.route.currentRoute()
    );

  /**
   * Check if on wizard/full-page route that should hide sub-header
   */
  get isFullPageRoute(): boolean {
    const route = this.route.currentRoute();
    return route.includes('/users/add');
  }

  get canSearch() {
    const route = this.route.currentRoute();
    if (route.includes('doc-new') ||
      route.includes('doc-edit'))
      return false;
    /**
     * Idea behind this logic is till 5th index of route.split
     * are list pages so we have to show search and after that there are
     * edit pages so we have to hide search
     *
     * Ex: /apps/645/tables/3337/forms/
     */
    if (!this.hideBreadCrumb) {
      return false;
    } else if (route.split('/').filter((e) => e).length > 5) {
      if (this.hideBreadCrumb) {
        return true;
      }
      return (
        route.includes('datatable/view') &&
        !route.includes('details') &&
        !route.includes('/form')
      );
    }
    return true;
  }

  get hideBreadCrumb() {
    const route = this.route.currentRoute();
    let res = true;
    if (route.includes('/profile') || route.endsWith('/apps')) {
      return false;
    }
    if (+route.split('/').filter((e) => e).length === 2) {
      res =
        this.dashboards?.find(
          (element: any) =>
            element.Key === element.Application.DefaultDashboardKey
        )?.HasTopNav !== 0;
    } else if (route.includes('settings/user-interface/dashboard/view')) {
      const dashboardKey = this.route.paramMap.dashboardId;
      res =
        this.dashboards?.find((element: any) => element.Key === dashboardKey)
          ?.HasTopNav !== 0;
    }
    return res;
  }

  /**
   * @returns true if super_admin
   */
  get isSuperAdmin() {
    return this.authService.userProfile?.Role === Roles.superAdmin;
  }

  /**

   * Get gutton text
   */
  get buttonText() {
    const route = this.route.currentRoute();

    if (['roles/create', 'copy-app/create'].some(r => route.includes(r)) ||
      (route.includes('roles/') && !route.endsWith('/roles')))
      return '';

    if (route.includes('/reports/datatable/view') &&
      !['/details', '/process', '/form', '/view-process'].some(r => route.includes(r))) {
      let tableName = 'Add New';
      this.store.pipe(
        select(getNavigation),
        filter(data => !!data[this.route.getApplicationKey()]),
        map(data => data[this.route.getApplicationKey()]
          .find(t => t?.LevelIds?.TableId == this.route.getTableKey())),
        take(1)
      ).subscribe(data => {
        tableName = 'Add ' + (data?.SingularReference || data?.Title || 'New');
      });

      return tableName === 'Add Audit Log' ? tableName : this.verticalDotsClass;
    }

    if (
      (route.includes('/details') && route.includes('/view')) ||
      ['/theme/view', '/dashboard/view', '/pages/view', '/layout/view']
        .some(suffix => route.includes('user-interface' + suffix)) ||
      (route.includes('/process/report/view') &&
        !route.includes('/view-process') &&
        this.route.paramMap.id &&
        !localStorage.getItem('isProcessWithPage')) ||
      (route.includes('/form') && (route.includes('/view') || route.includes('/action')) &&
        route.includes('/edit') && this.route.paramMap.formId)
    ) return this.verticalDotsClass;

    if (route.split('/').filter(Boolean).length > 5) return '';

    const mapping: Record<string, string> = {
      '/application': 'Add Table',
      '/field': '+ Add New Field',
      '/report': 'Add Report',
      '/relation': 'Add Relation',
      '/form': 'Add Form',
      '/roles': 'Add Role',
      '/imports': '+ Add Import',
      '/purge': '+ Add Purge',
      '/users': 'Add User',
      '/user-interface': 'Add',
      '/notifications': 'Add',
      '/tables': 'Add Table',
      '/clients': 'Add Client',
      '/templates': 'Add Template',
    };

    for (const key in mapping) {
      if (route.includes(key)) {
        if (key === '/field' && route.includes('/summary')) continue;
        if (key === '/relation' && route.includes('relation-visualize')) continue;
        if (key === '/tables' && route.includes('settings')) continue;
        return mapping[key];
      }
    }

    if (route.includes('/copy-app') && this.isSuperAdmin) return 'Add Copy App';

    return '';
  }


  get isSecondButton() {
    const route = this.route.currentRoute().split('/');
    if (route[route.length - 1] === 'imports') return true;
    if (
      route[route.length - 1] === 'users' &&
      route[route.length - 2] === 'user-management' &&
      route[route.length - 3] === 'settings'
    )
      return true;

    return false;
  }

  get secondButtonText() {
    const route = this.route.currentRoute();
    if (route.includes('/imports') && !route.includes('/imports/'))
      return 'Manage Purge';
    if (route.includes('/settings/user-management/users')) return 'Export Users';
    return '';
  }

  /**
   * Get form Id for
   */
  getFormId = () =>
    this.store
      .pipe(
        select(getFormIDs),
        filter(
          (formId) =>
            !!formId[this.route.getTableKey()] &&
            !!formId[this.route.getTableKey()][this.route.paramMap.reportId]
        ),
        map(
          (formId) =>
            formId[this.route.getTableKey()][this.route.paramMap.reportId]
        ),
        take(1)
      )
      .toPromise();
  /**
   * Get form Id for
   */
  getProcessFormId = () =>
    this.store
      .pipe(
        select(getProcessRecordDetails),
        filter((process) => !!process[this.route.getTableKey()] && !!process[this.route.getTableKey()][this.route.paramMap.reportId]),
        map((process) => process[this.route.getTableKey()][this.route.paramMap.reportId][this.route.paramMap.id]),
        take(1)
      )
      .toPromise();

  selectComponent = async () => {
    const route = this.route.currentRoute();
    if (route.includes('/import'))
      return this.route.navigate([
        '/apps',
        `${this.getAppId()}`,
        'tables',
        `${this.getTableId()}`,
        'purges',
      ]);
    if (route.includes('/settings/user-management/users')) {
      let appName = 'UsersForApplication_';
      this.subsink.add(
        this.store
          .pipe(
            select(getAppName),
            filter((apps) => !!apps),
            map((apps) => apps)
          )
          .subscribe((apps: any) => {
            if (apps[this.route.getApplicationKey()] != undefined) {
              appName = apps[this.route.getApplicationKey()] + '_';
            }
          }));
      let fileName = appName + 'users';

      this.store.dispatch(
        new LoadApplicationUsers(this.route.getApplicationKey())
      );
      this.report
        .getApplicationUsers(this.route.getApplicationKey())
        .pipe(take(1))
        .subscribe((users: any) => {
          let allUsers = users;
          let exportUsers: any[] = [];
          if (allUsers != undefined) {
            allUsers.forEach((el: any) => {
              exportUsers.push({
                Id: el.Id,
                Name: el.FullName,
                Email: el.Email,
                LastLogin: el.LastLogin,
                // el.LastLogin > 0
                //   ? moment.unix(el.LastLogin).format('MMMM Do YYYY, h:mm A')
                //   : '',
                TopLevelRole: el.TopLevelRole,
                AppRole: el.Role,
              });
            });
            this.exportService.csv(fileName, exportUsers);
          }
        });
    }
    return null;
  };
  /**
   * Select component to load in modal
   */
  componentSelector = async () => {
    const route = this.route.currentRoute();

    // Simple component mappings (no navigation)
    const simpleComponentResult = this.getSimpleComponentForRoute(route);
    if (simpleComponentResult) return simpleComponentResult;

    // Complex route handlers that require navigation or async logic
    if (route.includes('/details') && route.includes('/view')) {
      return this.handleDetailsViewRoute();
    }
    if (route.includes('/relation')) {
      return this.handleRelationRoute();
    }
    if (route.includes('/reports/datatable/view')) {
      return this.handleReportsViewRoute();
    }
    if (route.includes('/users')) {
      return this.handleUsersRoute();
    }

    // Navigation-based route handlers
    return this.handleNavigationRoutes(route);
  };

  private getSimpleComponentForRoute(route: string): any {
    if (route.includes('/field')) return UpsertFieldComponent;
    if (route.includes('/clients')) return AddClient;
    if (route.includes('/pages')) return UpsertPageComponent;

    // Check for navigation-only routes first (before /tables check)
    // These routes should not open modals, they navigate or are handled elsewhere
    if (route.includes('/import') || route.includes('/relation') ||
      route.includes('/report') || route.includes('/purges') ||
      route.includes('/notifications') || route.includes('/roles') ||
      route.includes('/copy-app') || route.includes('/form')) {
      return null; // Will be handled by specific route handlers or handleNavigationRoutes
    }

    if (route.includes('/application') || route.includes('/tables')) return AddTable;
    if (route.includes('/templates')) return AddTemplate;
    return null;
  }

  private async handleDetailsViewRoute(): Promise<any> {
    this.store.dispatch(
      new LoadFormID(this.route.getTableKey(), this.route.paramMap.reportId)
    );
    return this.route.navigate([
      '/apps',
      `${this.getAppId()}`,
      'tables',
      `${this.getTableId()}`,
      'reports',
      'datatable',
      'view',
      this.route.paramMap.reportId,
      'form',
      `${(await this.getFormId()).Key}`,
      'edit',
      this.route.paramMap.id,
    ]);
  }

  private handleRelationRoute(): Promise<boolean> {
    let routeParts = this.route.currentRoute().split('/');
    if (routeParts[routeParts.length - 1] !== 'relations') {
      routeParts = routeParts.slice(0, -1);
    }
    return this.route.navigate([routeParts.join('/'), 'create']);
  }

  private async handleReportsViewRoute(): Promise<boolean> {
    return this.route.navigate([
      '/apps',
      `${this.getAppId()}`,
      'tables',
      `${this.getTableId()}`,
      'reports',
      'datatable',
      'view',
      this.route.paramMap.reportId,
      'form',
      `${(await this.getFormId()).Key}`,
      'add',
    ]);
  }

  private handleUsersRoute(): any {
    // For OpenGov entities with feature flag enabled, navigate to add-user wizard
    if (this.isAddUserWizardEnabled && this.entityFriendlyId) {
      return this.route.navigate([
        '/apps',
        `${this.getAppId()}`,
        'settings',
        'user-management',
        'users',
        'add',
      ]);
    }
    return AddUser;
  }

  /**
   * Navigate to the Add User Wizard (used for non-OG entities dropdown)
   */
  navigateToAddUserWizard(): void {
    this.route.navigate([
      '/apps',
      `${this.getAppId()}`,
      'settings',
      'user-management',
      'users',
      'add',
    ]);
  }

  private handleNavigationRoutes(route: string): Promise<boolean> | null {
    if (route.includes('/roles')) {
      return this.route.navigate(['/apps', `${this.getAppId()}`, 'settings', 'user-management', 'roles', 'create']);
    }
    if (route.includes('/copy-app') && this.isSuperAdmin) {
      return this.route.navigate(['/apps', `${this.getAppId()}`, 'settings', 'copy-app', 'create']);
    }
    if (route.includes('/import')) {
      return this.route.navigate(['/apps', `${this.getAppId()}`, 'tables', `${this.getTableId()}`, 'imports', 'create']);
    }
    if (route.includes('/purges')) {
      return this.route.navigate(['/apps', `${this.getAppId()}`, 'tables', `${this.getTableId()}`, 'purges', 'create']);
    }
    if (route.includes('/notifications')) {
      return this.route.navigate(['/apps', `${this.getAppId()}`, 'tables', `${this.getTableId()}`, 'notifications', 'create']);
    }
    return null;
  }

  /**
   * Add dropdown-toggle-2 class
   * @returns true if add dropdown class to btn
   */
  get isDropdown() {
    const route = this.route.currentRoute();

    // For OpenGov entities on users route with feature flag enabled, show simple button (not dropdown)
    if (route.includes('/users') && this.isAddUserWizardEnabled && this.entityFriendlyId) {
      return false;
    }

    if (
      (route.includes('/report') && !route.includes('/view-process') && !route.includes('/copy') && !(route.includes('process') && localStorage.getItem('isProcessWithPage'))) ||
      route.includes('/users') ||
      route.includes('/user-interface') ||
      (route.includes('/form') && !route.includes('/copy')) ||
      route.includes('/notification') ||
      route.includes('details') ||
      route.includes('user-interface/theme/view') ||
      route.includes('user-interface/dashboard/view') ||
      route.includes('user-interface/pages/view') ||
      route.includes('user-interface/layout/view')
    )
      return true;
    return false;
  }

  get isIcon() {
    const route = this.route.currentRoute();
    if (route.includes('/details') || route.includes('/details/view')) return true;
    if (
      (((route.includes('/reports/datatable/view') && !(route.includes('process') && localStorage.getItem('isProcessWithPage'))) ||
          (route.includes('/reports/datatable/view') && route.includes('/form') && route.includes('/edit') && this.route.paramMap.formId) ||
          (route.includes('/reports/datatable/view') && route.includes('/process') && (this.route.paramMap.id)) ||
          (route.includes('/reports') && route.includes('/view') && route.includes('/process') && (this.route.paramMap.id)) ||
          (route.includes('/forms/action/edit'))) &&
        !route.includes('/details') &&
        !(route.includes('/form') && route.includes('/add'))) ||
      route.includes('user-interface/theme/view') ||
      route.includes('user-interface/dashboard/view') ||
      route.includes('user-interface/pages/view') ||
      route.includes('user-interface/layout/view')
    ) return true;
    return false;
  }

  get allowEdit() {
    return localStorage.getItem('allowEdit');
  }

  /**
   * Load dropdown template on the basis of route
   */
  loadDropdownTemplate = () => {
    const route = this.route.currentRoute();
    if (route.includes('/report') && !route.includes('/details') && !route.includes('/datatable/view') && !route.includes('process')) return this.addReport;
    if (route.includes('/users')) return this.addUser;
    if (route.includes('/user-interface') && !(route.includes('/view') || route.includes('/edit'))) return this.addPageDashboard;
    if (route.includes('/form') && !route.includes('/edit') && !route.includes('/copy')) return this.addForm;
    if (route.includes('/notifications')) return this.addNotification;
    if (route.includes('/details') || route.includes('/details/view')) return this.editRecord;
    if (route.includes('/process') && this.route.paramMap.id) return this.editRecord;
    if (route.includes('/form') && route.includes('/edit') && this.route.paramMap.formId) return this.editRecord;
    if (route.includes('/reports/datatable/view') && !route.includes('/copy') && !route.includes('/edit')) return this.addRecord;
    if (route.includes('/user-interface') && (route.includes('/view') || route.includes('/edit'))) return this.editUserInterface;
    return null;
  };

  get isEditForm() {
    const route = this.route.currentRoute();
    return route.includes('/form') && route.includes('/edit') && this.route.paramMap.formId;
  }

  searchText() {
    this.searchService.onInputChange(this.search);
  }

  setSearch = (event: any) => {
    this.search = event.target.value;
  };

  /**
   * Toggle search
   */
  toggleSearch(input: HTMLInputElement) {
    this.isSearchVisible = !this.isSearchVisible;
    if (!this.isSearchVisible) {
      this.search = '';
      this.searchService.onInputChange('');
    } else {
      input?.focus();
    }
  }

  /**
   * Generate route link
   */
  generateReportLink = (link: string) => `${this.route.currentRoute()}/${link}`;

  /**
   * Generate Dashboard create link
   */
  generateDashboardLink = (link: string) => {
    const segments = this.route.currentRoute().split('/').filter(Boolean);
    segments.pop();
    return `${segments.join('/')}/${link}`;
  }

  isChatBotEnabled() {
    return this.isAdminOrSuperAdmin() && this.route.paramMap.reportId && !(this.route.paramMap.formId || this.route.paramMap.id);
  }

  onChangeChatBotWidget() {
    this.isChatWidget = !this.isChatWidget;
  }

  async performViewRecordOperation(link: string = '') {
    const formId = this.route.paramMap.formId ?? '';
    const reportId = this.route.paramMap.reportId;
    const tableKey = this.route.getTableKey();
    const id = this.route.paramMap.id;
    const appId = this.getAppId();
    const tableId = this.getTableId();
    const route = this.route.currentRoute();

    const loadFormIfNeeded = async () => {
      if (!formId) {
        this.store.dispatch(new LoadFormID(tableKey, reportId));
        const result = await this.getFormId();
        return result.Key;
      }
      return formId;
    };

    const getProcessFormKey = async () => {
      const result = await this.getProcessFormId();
      return result.FormKey;
    };

    switch (link) {
      case 'edit-record': {
        if (route.includes('/details') && route.includes('/view')) {
          const resolvedFormId = await loadFormIfNeeded();

          this.route.navigate([
            '/apps', appId, 'tables', tableId, 'reports', 'datatable', 'view',
            reportId, 'form', resolvedFormId, 'edit', id
          ]);

          this.storageService.removeEditProcess(reportId);

        } else if (route.includes('/process') && route.includes('/view')) {
          this.store.dispatch(new ViewProcessRecordDetails(tableKey, reportId, id));
          const processFormKey = await getProcessFormKey();

          this.route.navigate([
            '/apps', appId, 'tables', tableId, 'reports', 'datatable', 'view',
            reportId, 'form', processFormKey, 'edit', id
          ]);

          this.storageService.saveEditInProcess(reportId, processFormKey);
        }
        break;
      }

      case 'edit-form': {
        const resolvedFormId = await loadFormIfNeeded();

        this.route.navigate([
          '/apps', appId, 'tables', tableId, 'forms', 'web', resolvedFormId
        ]);
        break;
      }

      case 'delete-record': {
        this.deleteRecord();
        break;
      }

      case 'add-record': {
        this.store.dispatch(new LoadFormID(tableKey, reportId));
        const resolvedFormId = await this.getFormId();

        this.route.navigate([
          '/apps', appId, 'tables', tableId, 'reports', 'datatable', 'view',
          reportId, 'form', resolvedFormId.Key, 'add'
        ]);
        break;
      }

      case 'edit-report': {
        const segments = route.replace('/view', '').split('/');
        const datatableIndex = segments.indexOf('datatable');
        const newRoute = segments.slice(0, datatableIndex + 2);

        this.route.navigate(newRoute);
        break;
      }

      case 'print-record': {
        this.commonService.printForm.emit();

        // Auto-expand all textareas to show full content.
        // Note: the css `@media print` change in `src/styles.scss` fix the printing cutoff issue in Chrome, but
        // Firefox still needs this js control to make it work properly.
        const textareas = document.querySelectorAll('textarea');
        textareas.forEach((textarea: HTMLTextAreaElement) => {
          // Reset height to recalculate scrollHeight
          textarea.style.height = 'auto';
          // Set height to scrollHeight to show all content
          if (textarea.scrollHeight > 0) {
            textarea.style.height = `${textarea.scrollHeight + 4}px`;
          }
        });

        const defaultDelay = 100;
        const delayValue = await this.ldService.getFlagValue(FEATURE_FLAGS.PRINT_RECORD_DELAY, defaultDelay)
          .pipe(take(1))
          .toPromise();

        const delay = typeof delayValue === 'number' ? delayValue : defaultDelay;

        // Small delay to ensure heights are applied before print dialog
        setTimeout(() => {
          window.print();

          // Reset heights after printing (on window focus)
          const resetHeights = () => {
            textareas.forEach((textarea: HTMLTextAreaElement) => {
              textarea.style.height = '';
            });
            window.removeEventListener('focus', resetHeights);
          };

          // Reset when user closes print dialog
          window.addEventListener('focus', resetHeights, { once: true });
        }, delay);

        break;
      }

      case 'copy-record': {
        const resolvedFormId = await loadFormIfNeeded();

        this.route.navigate([
          '/apps', appId, 'tables', tableId, 'reports', 'datatable', 'view',
          reportId, 'form', resolvedFormId, 'copy', id
        ]);
        break;
      }

      default:
        break;
    }
  }

  deleteRecord() {
    let id = this.route.paramMap.id;
    const payload: DependentRecords = {
      ApplicationKey: this.route.getApplicationKey(),
      ApplicationTableKey: this.route.getTableKey(),
      IsBulkUpdateDelete: true,
      Where: {
        Rids: [id],
      },
    };
    this.store.dispatch(
      new LoadDependentRecords(this.route.getTableKey(), id, payload)
    );

    let getDependentRecordsSubscriber = this.store
      .pipe(
        select(getDependentRecords),
        filter(
          (records) =>
            !!records[this.route.getTableKey()] &&
            !!records[this.route.getTableKey()][id]
        ),
        map((records) => records[this.route.getTableKey()][id]),
        take(1)
      )
      .subscribe((records: any) => {
        if (!Object.keys(records.data).length) {
          // delete record by id
          this.alert
            .fire(<SweetAlertOptions>alertPresets.delete)
            .then(async (res) => {
              if (res.isConfirmed) {
                try {
                  await this.action.dispatch(
                    OpTypes.DELETE,
                    new DeleteObject(payload),
                    getFormOperations,
                    {
                      ...alertDefaultExtra,
                      success: {
                        ...alertDefaultExtra.success,
                        show: true,
                        title: 'Success',
                        message: 'Record Deleted'
                      }
                    }
                  );
                  this.route.back();
                } catch (err) {
                  console.log(err);
                }
              }
            });
        } else {
          let route = `/apps/${this.route.getApplicationKey()}/settings/relation-visualize`;
          let tag = `<a href="${route}" target="_blank">view hierarchy</a>`;
          let message = '';
          let map = new Map(Object.entries(records.data));

          if (map.size != 0) {
            if (map.size > 1) {
              message +=
                'This will also delete all records in child tables:<br>';
            } else {
              message +=
                'This will also delete all records in child table:<br>';
            }
            map.forEach(function (value: any, key: any) {
              if (value > 1) {
                message += key + ' - ' + value + ' records<br>';
              } else if (value == 1) {
                message += key + ' - ' + value + ' record<br>';
              }
            });

            if (message) {
              message += '<br>' + tag;
            }
            if (message) {
              message += '<br><br>' + 'Once you delete the record, there is no going back.';
            }
          }
          this.alert
            .fire(<SweetAlertOptions>{
              ...alertPresets.deleteRecords,
              html: message,
            })
            .then(async (res) => {
              if (res.isConfirmed) {
                if (res.value === 'delete') {
                  try {
                    await this.action.dispatch(
                      OpTypes.DELETE,
                      new DeleteObject(payload),
                      getFormOperations,
                      {
                        ...alertDefaultExtra,
                        success: {
                          ...alertDefaultExtra.success,
                          show: true,
                          title: 'Success',
                          message: 'Record Deleted'
                        }
                      }
                    );
                    this.route.back();
                  } catch (err) {
                    console.log(err);
                  }
                } else {
                  this.alert
                    .fire(<SweetAlertOptions>{
                      ...alertPresets.deniedDeleteApp,
                      title: 'Confirmation Denied!'
                    })
                }
              }
            });
        }
      });

    this.subsink.add(getDependentRecordsSubscriber);
  }

  getAddRecordtext(item: any) {
    if (item.link == 'add-record') {
      let tableName = 'Add New';
      this.store
        .pipe(
          select(getNavigation),
          filter((data) => !!data[this.route.getApplicationKey()]),
          map((data) =>
            data[this.route.getApplicationKey()].find(
              (t) => t?.LevelIds?.TableId == this.route.getTableKey()
            )
          ),
          take(1)
        ).subscribe((data) => {
        tableName =
          'Add ' +
          (data?.SingularReference != '' && data?.SingularReference != null
            ? data?.SingularReference
            : data?.Title || 'New');
      });

      return tableName;
    }
    return item.title
  }

  getItemCondition(itemLink: string = '') {
    if ((itemLink === 'add-record' || itemLink === 'edit-form' || itemLink === 'edit-record' || itemLink === 'delete-record' || itemLink === 'copy-record') && this.route.currentRoute().includes('summaryFieldId')) {
      return false;
    }

    if (this.isAdminOrSuperAdmin()) return true;

    const applicationKey = this.route.getApplicationKey();
    const tableKey = this.route.getTableKey();

    if (itemLink === 'edit-record' && this.allowEdit === null) {
      return false;
    }

    const permissions = {
      createRight: 0,
      updateRight: 0,
      deleteRight: 0,
      manageForms: 0
    };

    const setManageForms = (el: any) => {
      if (el.ApplicationKey === applicationKey) {
        el.ApplicationRoleManagements?.forEach((role: any) => {
          if (role.ApplicationTableKey === tableKey && role.ApplicationRoleManagementType?.Name === 'Manage Forms') {
            permissions.manageForms = 1;
          }
        });
      }
    };

    const applicationRoles = this.authService.userProfile?.ApplicationRoles;
    if (applicationRoles) {
      for (const role of applicationRoles) {
        const isAppKeyMatch = role.ApplicationKey === applicationKey || role.ApplicationId === applicationKey;
        if (isAppKeyMatch) {
          for (const permission of role.Rights) {
            const isTableKeyMatch = permission.ApplicationTableKey === tableKey || permission.ApplicationTableId === tableKey;
            if (isTableKeyMatch) {
              permissions.createRight = permission.Create;
              permissions.updateRight = permission.Update;
              permissions.deleteRight = permission.Delete;
            }
          }
        }
      }
    }

    switch (itemLink) {
      case 'add-record':
        return permissions.createRight === 1;
      case 'edit-record':
        return permissions.updateRight === 1;
      case 'delete-record':
        return permissions.deleteRight === 1;
      case 'print-record':
        return true;
      case 'edit-form':
        this.authService.userProfile?.ApplicationRoles?.forEach(setManageForms);
        return permissions.manageForms === 1;
      default:
        return false;
    }
  }

  isAddItemVisible(item: any): boolean {
    if (item.link === 'metabase-dashboard/create') {
      return this.isSuperAdmin && this.isOgInsightsEnabled;
    }
    if (item.link === 'superset-dashboard/create') {
      return this.isSuperAdmin && !this.isOgInsightsEnabled;
    }
    return true;
  }

  isItemVisible(link: string) {
    const route = this.route.currentRoute();
    const userInterface = link.split('-')[1];
    return route.includes(userInterface)
  }

  performUserInterfaceroute(link: string) {
    const userInterface = link.split('-')[1];
    switch (userInterface) {
      case 'dashboard':
        this.route.navigate([
          'apps',
          this.route.getApplicationKey(),
          'settings',
          'user-interface',
          userInterface,
          'edit',
          this.route.paramMap.dashboardId
        ])
        break;
      case 'page':
        this.route.navigate([
          'apps',
          this.route.getApplicationKey(),
          'settings',
          'user-interface',
          'pages',
          'edit',
          this.route.getPageKey()
        ])
        break;
      case 'theme':
        this.route.navigate([
          'apps',
          this.route.getApplicationKey(),
          'settings',
          'user-interface',
          userInterface,
          'edit',
          this.route.getThemeKey()
        ])
        break;
      case 'layout':
        this.route.navigate([
          'apps',
          this.route.getApplicationKey(),
          'settings',
          'user-interface',
          userInterface,
          'edit',
          this.route.getLayoutKey()
        ])
        break;
    }
  }


  /**
   * @returns where the Help Widget will be shown
   */

  get isHelpWidgetShow(): boolean {
    if (this.route.currentRoute().endsWith('/apps')) return false;
    const hasAppId = !!this.getAppId();
    if (this.route.isCustomUrl || this.route.currentRoute().includes('/profile')) {
      return hasAppId && this.IsHelpDeskWidgetActive;
    }

    return !hasAppId || this.IsHelpDeskWidgetActive;
  }

  getWidgetActiveStatus = () => {
    this.subsink.add(
      this.store.pipe(
        select(getApplicationById),
        filter((data) => !!data[this.route.getApplicationKey()]),
        map((apps) => apps[this.route.getApplicationKey()])
      ).subscribe((data) => {
        this.IsHelpDeskWidgetActive = data.ApplicationSetting?.IsHelpDeskWidgetActive || false;
        this.icon = data?.IsIcon;
        this.isGlobalNavVisible = data.ApplicationSetting?.IsGlobalNavVisible || false;
      }));
  }

  /**
   * @returns sideBar Height
   */
  get sideBarHeight() {
    if (window.innerWidth <= 1024) {
      if (!this.icon || this.route.currentRoute().endsWith('/apps')) {
        return 37;
      } else if (this.icon) {
        return 97;
      }
    }
    return 20;
  }

  /**
   *
   * @returns navigate back the url
   */

  navigateBack = () => {
    if (this.route.historyStack.length > 1) this.route.back()
  };

  /**
   *
   * @returns refreshes the web page
   */

  refreshContent = () => window.location.reload();

  /**
   *
   * @returns to show the back button in the web page
   */

  getBackBtn = () => this.route.historyStack.length > 1 && this.isButtonVisible();


  /**
   * @returns to show the refresh button in the web page
   */
  isButtonVisible = () => !this.route.currentRoute().includes('/profile') && !this.route.currentRoute().endsWith('/apps');

  /**
   * @returns full name
   */
  fullName = () => {
    let name = `${this.authService.userProfile?.FirstName || ''} ${
      this.authService.userProfile?.LastName || ''
    }`;

    if (this.isImpersonate) {
      name += ' [Impersonated]';
    }
    return name;
  };

  /**
   * @returns email
   */
  email = () => this.authService.userProfile?.Email;

  logout = () => this.authService.logout(true, true, this.storageService.getPortalId());

  /**
   * Restore Super Admin
   */
  restoreSuperAdmin = () => {
    let impersonatedId = this.storageService.getImpersonateId() || '';
    if (impersonatedId)
      this.store.dispatch(new ReturnToSuperAdmin(impersonatedId));
  };
  executeTodayFormulas = async () => {
    this.alert
      .fire(<SweetAlertOptions>{
        ...alertPresets.delete,
        title: 'Execute today formulas',
        text: 'Are you sure?',
        confirmButtonText: 'Yes',
      })
      .then(async (res) => {
        if (res.isConfirmed) {
          await this.fieldService.executeTodayFormulas().toPromise();
        }
      });
  }


  ngOnDestroy() {
    this.subsink.unsubscribe();
    // Clean up event listeners
    if (this.storageEventHandler) {
      window.removeEventListener('storage', this.storageEventHandler);
    }
    if (this.entityFriendlyIdUpdatedHandler) {
      window.removeEventListener('entityFriendlyIdUpdated', this.entityFriendlyIdUpdatedHandler);
    }
  }
}
